export default [
  {
    type: 'update_date',
    content: 'Updated at 18 July 2023',
  },
  {
    type: 'subtitle',
    content: '1. Introduction',
  },
  {
    type: 'text',
    content:
      '<strong>1.1 </strong> These Terms and Conditions constitute a legally binding agreement between you (either personally or on behalf of an entity you represent) and Nakhla IT Systems LLC ("Tamara"), hereinafter referred to as "We", with respect to all aspects of the Tamara Services and/or your use of the Mobile App or your access to our Website, as well as any other media form, media channel, website or mobile application related to, or linked to and through your access to and use of the Mobile App or Website. You acknowledge that you have read, understood and agreed to be bound by these Terms and Conditions, as amended from time to time. If you do not agree to these Terms and Conditions, you must stop using or accessing the Mobile App and/or Website immediately. If you are using the Mobile App or the Website on behalf of a third party including, without limitation, any business entity, you warrant that you are authorised and have the authority to commit the third party to these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>1.2 </strong> The Merchant from whom you purchase goods or services using Tamara Services is not a party to these Terms and Conditions and any applicable terms between you and the Merchant are independent of these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>1.3</strong> We reserve the right, at our absolute discretion, to make changes or modifications to these Terms and Conditions at any time and for any reason. We shall provide you with a thirty (30) business days’ notice of any change to these Terms and Conditions via the agreed means of communication as further described below. You shall have the opportunity to object to any such change within ten (10) business days after receiving a notification from Tamara.',
  },
  {
    type: 'text',
    content:
      '<strong>1.4</strong> You acknowledge your responsibility to review these Terms and Conditions periodically for the latest developments, and you waive any right to receive specific notice of each such change. Your continued use of the Website and/or the Mobile App after the date of publication of the revised Terms and Conditions shall constitute an acknowledgement from you that you have read and understood the amendments and accepted the commitment.',
  },
  {
    type: 'text',
    content:
      '<strong>1.5</strong> This preamble is an integral part of these Terms and Conditions.',
  },
  {
    type: 'subtitle',
    content: '2. Definitions',
  },
  {
    type: 'text',
    content:
      'The following references, words, expressions and terms have the meanings set forth in front of each of them in these terms and conditions:',
  },
  {
    type: 'text',
    content:
      '<strong>Applicable Laws:</strong> means any applicable laws and regulations to which Tamara and/or the Customer.',
  },
  {
    type: 'text',
    content:
      '<strong>Customer:</strong> means the customer of the Merchant or Merchant Platform who creates a Tamara Account.',
  },
  {
    type: 'text',
    content:
      '<strong>Dispute:</strong> means any request for refund, deduction, compensation, counterclaim or dispute of any kind brought by the Customer against the Merchant in respect of the goods or services that resulted in an approved Transaction.',
  },
  {
    type: 'text',
    content: `<strong>Force Majeure:</strong> means any circumstance not within a party's reasonable control including, without limitation: (i) acts of God, flood, drought, earthquake or other natural disaster; (ii) epidemic or pandemic; (iii) terrorist attack, civil war, civil commotion or riots, war, threat of or preparation for war, armed conflict, imposition of sanctions, embargo, or breaking off of diplomatic relations; (iv) nuclear, chemical or biological contamination or sonic boom; (v) any law or any action taken by a government or public authority, including without limitation imposing an export or import restriction, quota or prohibition, or failing to grant a necessary licence or consent; (vi) collapse of buildings, fire, explosion or accident; and (vii) interruption or failure of utility service.`,
  },
  {
    type: 'text',
    content:
      '<strong>Identification Information:</strong> means the information required to be provided by the Customer to Tamara in order to create an account for them with Tamara, as collected by Tamara or the Merchant or Merchant Platform for the purposes of providing Tamara Services to Customers.',
  },
  {
    type: 'text',
    content:
      '<strong>Intellectual Property Rights:</strong> means any patents, utility models, rights to inventions, copyright and related rights, trade marks and service marks, trade names and domain names, rights in get-up, goodwill and the right to sue for passing off or unfair competition, rights in designs, rights in computer software, database rights, rights to preserve the confidentiality of information (including know-how and trade secrets) and any other intellectual property rights, including all applications for (and rights to apply for and be granted), renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist, now or in the future, in any part of the world.',
  },
  {
    type: 'text',
    content:
      '<strong>Merchant Platform:</strong> means the means, including but not limited to websites and applications, which allow multiple Merchants to offer goods and services to customers through a single platform.',
  },
  {
    type: 'text',
    content:
      '<strong>Merchant:</strong> means any commercial entity that provides Tamara Services to its customers pursuant to an agreement between it and Tamara, or between Tamara and the Merchant Platform, as updated from time to time.',
  },
  {
    type: 'text',
    content:
      '<strong>Mobile App:</strong> means the Tamara mobile application as available to download from the relevant digital stores.',
  },
  {
    type: 'text',
    content:
      '<strong>Net Amount:</strong> means the total amount to be paid by the Customer including, where applicable, any value-added tax and shipping charges in connection with a Purchase Order that gives rise to one approved Transaction minus: (i) any Refunds; and (ii) any deductions, credits or reductions claimed by the Customer and approved by the relevant Merchant.',
  },
  {
    type: 'text',
    content:
      '<strong>Purchase Order:</strong> means the request submitted by the Customer through the platform the Website, Mobile App, the Merchant’s website, or any other applications or points of sale to use the Tamara Services to purchase goods or services from the relevant Merchant or Merchant Platform.',
  },
  {
    type: 'text',
    content:
      '<strong>Refunds:</strong> means a disputed amount paid by the Customer to a Merchant using the Tamara Services in connection with an approved transaction which is subsequently returned to the Customer following the resolution of such Dispute.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Account:</strong> means the account created by the Customer to use the Tamara Services, whose use and operation will be subject to these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Services:</strong> means the payment services provided by Tamara, as updated from time to time, that the Customer selects on the Merchant’s website, the Merchant Platform or at any other point of sale with the Merchant or on the Merchant Platform under which the Customer chooses to purchase goods or services from the Merchant or Merchant Platform using the Tamara Services subject to these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>Transaction</strong> means a request submitted via your Tamara Account, pursuant to a Purchase Order, to make use of the Tamara Services in order to complete and settle such Purchase Order with the relevant Merchant.',
  },
  {
    type: 'text',
    content:
      '<strong>Transaction Information:</strong> means all information related to the Purchase Order and the Transaction.',
  },
  {
    type: 'text',
    content:
      '<strong>We:</strong> References to “we” or “we” as a possessive, object, or other similar pronouns in these Terms and Conditions are references to Tamara and its affiliated entities and persons.',
  },
  {
    type: 'text',
    content: `<strong>Website:</strong> means Tamara's website at https://tamara.co.`,
  },
  {
    type: 'text',
    content: `<strong>You:</strong> References to “you”, or the possessive pronoun “your” or other similar pronouns in these Terms and Conditions are references to the relevant Customer referred to in the Identification Information to be provided prior to using the Tamara Services.`,
  },
  {
    type: 'subtitle',
    content: '3. Eligibility and Validity:',
  },
  {
    type: 'text',
    content:
      '<strong>3.1</strong> By using the Tamara Services you warrant and represent that you have the legal capacity to enter into these Terms and Conditions and that you are over the age of eighteen (18) years.',
  },
  {
    type: 'text',
    content:
      '<strong>3.2</strong> If you register as a business entity, legal person or any other entity, your warrant and represent that you have the necessary authority and capacity to enter into and to bind your entity to these Terms and Conditions, and that you, as well as the business entity, will comply with all Applicable Laws and requirements.',
  },
  {
    type: 'text',
    content:
      '<strong>3.3</strong> By clicking to agree to these Terms and Conditions, you acknowledge that you have accepted these Terms and Conditions electronically.',
  },
  {
    type: 'subtitle',
    content: '4. Accounts and Registration:',
  },
  {
    type: 'text',
    content:
      '<strong>4.1</strong> The process of registering the Tamara Account requires you to provide Tamara with certain personal information for the purposes of (i) creating a Tamara Account; (ii) providing any Tamara Services; and (iii) complying with any Applicable Laws or regulations, including, but not limited to, any “Know Your Customer” compliance obligations. Such information may include your full name, address, email, phone number and age. You acknowledge and agree that any personal information provided is true, accurate, complete and up-to-date, and you shall promptly notify Tamara of any changes to your personally identifiable information or any other information or circumstances that may affect your eligibility to continue to use the Tamara Services or are otherwise required in accordance with these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>4.2</strong> You hereby agree to disclose all of your financial obligations, as requested by Tamara or any of its agents or subcontractors, and to refrain from withholding any information that may be impactful or important to any of the parties to the financing agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>4.3</strong> You hereby agree that you will be responsible for any activity under your Tamara Account and agree to maintain appropriate security measures for your account details on an ongoing basis.',
  },
  {
    type: 'text',
    content:
      '<strong>4.4</strong> If your password is lost or stolen, or if you believe that there is unauthorised access to your Tamara Account, you must change the password for your Tamara Account and notify us immediately. You are responsible for any Transactions made using your stolen Tamara Account credentials unless you promptly notify us of the suspension and receive      a message from Tamara stating that your Tamara Account is suspended or terminated.',
  },
  {
    type: 'text',
    content:
      '<strong>4.5</strong> You shall not share your Tamara Account credentials with any other person. You acknowledge and agree to refund to Tamara the value of any Transaction made using your Tamara Account which was requested by you or by any other person who has accessed the Tamara Services through the use of your own username or password, whether or not you have allowed such access.',
  },
  {
    type: 'text',
    content:
      '<strong>4.6</strong> You shall immediately notify Tamara of any suspected or actual fraudulent or illegal activity identified as a result of your use of the Tamara Services. Failure to do so may result in suspension or termination of your Tamara Account, as well as any other additional legal action taken by Tamara at its full discretion. Where the suspected or actual fraudulent or illegal activity originates from a Merchant or Merchant Platform using Tamara Services, you shall immediately report such Merchant to Tamara before taking any further action.',
  },
  {
    type: 'text',
    content:
      '<strong>4.7</strong> At its full discretion, should Tamara have any doubts that any of the information you provided is incorrect, inaccurate, incomplete or not up to date, without prejudice to any other rights or remedies, in accordance with these Terms and Conditions or pursuant to the Applicable Laws, Tamara shall have the right to stop or restrict access to the Services, the Mobile App and/or the Website.',
  },
  {
    type: 'text',
    content: `<strong>4.8</strong> Tamara may, at its full discretion, make any inquiries it deems necessary (whether directly or through a third party), and request you to provide further information or documents as deemed necessary. If you are an employer or registered on behalf of an employer, such information or documents may include a business licence and other official company documents and/or documents that demonstrate any person's authority to act on your behalf. You acknowledge and agree to provide any information and/or documents to Tamara upon request. You further acknowledge and agree that if you are unable to do so, Tamara may, without any liability, limit, suspend or withdraw your access to the Services, Mobile App or Website. Tamara reserves the right to cancel any unconfirmed or unverified accounts or accounts that have not been active at its full discretion.`,
  },
  {
    type: 'text',
    content: `<strong>4.9</strong> Upon completing the registration process, you acknowledge and agree that you have read these Terms and Conditions, understand them and agree to be bound by them. These Terms and Conditions shall be deemed to include the Tamara Privacy Policy, available https://tamara.co/en/privacy-policy.html and as updated from time to time.`,
  },
  {
    type: 'text',
    content: `<strong>4.10</strong> Where your application for a Tamara Account or the provision of any specific Tamara Services has been rejected, we shall inform you of the reason for such rejection within five (5) business days.`,
  },
  {
    type: 'subtitle',
    content: '5. Tamara Services',
  },
  {
    type: 'text',
    content:
      '<strong>5.1</strong> Tamara is an online payments provider offering Customers a variety of payment methods when purchasing goods or services through various Merchants or Merchant Platforms.',
  },
  {
    type: 'text',
    content:
      '<strong>5.2</strong> The Tamara Website and Mobile App display a list of independent Merchants who accept Tamara as a payment option, as updated from time to time. These Merchants have entered into binding agreements with Tamara to provide such products or services through the Merchant websites, apps or Merchant Platforms.',
  },
  {
    type: 'subtitle',
    content: '6. Electronic Communication',
  },
  {
    type: 'text',
    content:
      '<strong>6.1</strong> By creating a Tamara Account, you acknowledge and agree that you will communicate with us electronically. Therefore, you agree that Tamara may provide all communications, payment information, terms and conditions, information we are required to provide by law, all communications regarding any complaints and other information to you electronically to the email address you have provided to us.',
  },
  {
    type: 'text',
    content:
      '<strong>6.2</strong> To ensure that we are able to communicate with you electronically, you agree that it is your responsibility to notify us immediately of any change to your email address and mobile phone number or other information you provide to us. We may occasionally contact you to request an update of such information and any other information related to your Tamara Account.',
  },
  {
    type: 'subtitle',
    content: '7. Intellectual Property Rights',
  },
  {
    type: 'text',
    content:
      '<strong>7.1</strong> You acknowledge that all Intellectual Property Rights on the Website and/or Mobile App (as applicable), shall automatically belong to Tamara, its licensors or third-party Merchants, to the fullest extent permitted by law.',
  },
  {
    type: 'text',
    content:
      "<strong>7.2</strong> The Tamara logo and associated symbols are trade marks of Tamara. Tamara's trade marks may not be used in connection with any product or service that is not offered by Tamara, including any product or service that disparages Tamara or harms its reputation.",
  },
  {
    type: 'text',
    content:
      '<strong>7.3</strong> You are prohibited from using any trade mark or any Intellectual Property Rights belonging to Tamara, from any part of the Tamara Services, and are prohibited from reproducing or modifying the Tamara Services or conducting any process of preparing, publishing, executing, sending, displaying, broadcasting or other means of exploiting the Tamara Services unless Tamara permits or expressly authorizes it in writing. In addition, you may not, and you agree not to or enable others to, copy, decompile, reverse engineer, disassemble, attempt to derive the source code of, decrypt, modify, or create derivative works of the Tamara Services or any part thereof (except as and only to the extent any foregoing restriction is prohibited by Applicable Laws).',
  },
  {
    type: 'subtitle',
    content: '8. Using the Website and Mobile App',
  },
  {
    type: 'text',
    content:
      '<strong>8.1</strong> You are prohibited from using the Tamara Website and/or Mobile App to post any of the following content: any use of vulgar language, obscenity, insults, cultural or religious abuse, any political or critical content, or material that may threaten the public interest or national security, cause defamation, slander, libel, or any other content that may be offensive, obscene or indecent.',
  },
  {
    type: 'subtitle',
    content: '9. Product lists and availability',
  },
  {
    type: 'text',
    content:
      '<strong>9.1</strong> You understand that Tamara is merely a payments provider and does not bear any responsibility for the manufacturing, shipping, production or delivery of any of the products or services purchased via Tamara. Accordingly, Tamara shall not be liable for the availability, qualify or any other characteristic of any products that are displayed on the Merchant’s website, app or the Merchant Platform.',
  },
  {
    type: 'subtitle',
    content: '10. After-sales service for products:',
  },
  {
    type: 'text',
    content:
      '<strong>10.1</strong> Tamara shall not be liable or responsible for any products or services sold through any Merchant websites, apps or Merchant Platforms. Such products and services will be provided and supported by Merchants, their manufacturers or their local agents only, as well as their suppliers, in accordance with the terms and conditions associated with each product or service. Tamara expressly excludes any warranty of any kind for the products or services sold on the Merchant websites, apps and Merchant Platforms. Any requests for technical support, customer service or after-sales service regarding products or services shall be directed to the Merchant concerned.',
  },
  {
    type: 'subtitle',
    content: '11. Payments:',
  },
  {
    type: 'text',
    content:
      '<strong>11.1</strong> Once you have created a Tamara Account in accordance with these Terms and Conditions, you will be able to access the Tamara Services when you choose to pay for goods or services using the Tamara Services payment option with the relevant Merchant or Merchant Platform.',
  },
  {
    type: 'text',
    content:
      '<strong>11.2</strong> Tamara Services allow you to purchase goods or services from a Merchant or Merchant Platform. When you choose one of Tamara’s payment options, different terms and conditions may apply in addition to these Terms and Conditions, and fees may be charged by Tamara, which are subsequently payable by you.',
  },
  {
    type: 'text',
    content:
      '<strong>11.3</strong> You are responsible for understanding and accepting all fees associated with your Purchase Order as specified during the payment process. Where any late amount is applicable, you undertake to pay it to Tamara.',
  },
  {
    type: 'text',
    content: `<strong>11.4</strong> Once you have chosen Tamara's Services at the Merchant's point of sale during the payment process, you will be asked to choose a payment method that will become effective and binding between you and Tamara in relation to the Purchase Order.`,
  },
  {
    type: 'text',
    content:
      '<strong>11.5</strong> Service fees may be applicable for certain payment methods and/or Merchants. The amount of such fees will be clearly displayed during checkout. You are responsible for reviewing your total amount before finalising the Transaction to ensure that you are aware of all charges applicable.',
  },
  {
    type: 'text',
    content:
      '<strong>11.6</strong> Where such information is not already available via the Tamara Website and/or Mobile App, you shall be entitled to request a copy of the entire agreement you have with us within ten (10) business days after the conclusion of the agreement, as well as any applicable transaction statements (including all fees, term cost, costs and all additional charges, in case of default or early repayment of finance) on a quarterly basis.',
  },
  {
    type: 'text',
    content:
      '<strong>11.7</strong> You acknowledge that you are fully responsible for any Purchase Order, Transaction, or any fees associated with the Tamara Services, regardless of whether the goods or services concerned are successfully delivered or provided to you (as applicable).',
  },
  {
    type: 'text',
    content:
      '<strong>11.8</strong> Tamara reserves the right to make any change or modification to any payment method or the provision of the Tamara Services.',
  },
  {
    type: 'text',
    content:
      '<strong>11.9</strong> Tamara provides electronic payment services through third-party service providers. Tamara shall not bear any liability for any error, damage or any loss that      you may be exposed to as a result of using an electronic payment method. This is the responsibility of the third-party service provider.',
  },
  {
    type: 'text',
    content:
      '<strong>11.10</strong> You must ensure that you have sufficient funds in your Tamara Account, prior to submitting a Purchase Order or attempting to complete a Transaction. You are solely responsible for complying with any applicable transaction limits.',
  },
  {
    type: 'text',
    content:
      '<strong>11.11</strong> Under these Terms and Conditions, you agree and authorise Tamara to withdraw the relevant amount necessary to complete a Transaction from the payment method stored in your Tamara Account on the date due for payment. In the event that a Transaction is rejected due to lack of funds covering the premium, an attempt to deduct such funds will be automatically made every two (2) days until the full amount is paid. Tamara reserves the right to refer your case to any applicable credit collection agency and/or share your details with any applicable regulators at its full discretion',
  },
  {
    type: 'text',
    content:
      '<strong>11.12</strong> You hereby acknowledge that Tamara is entitled to verify your credit score, obtain your credit report, and verify your identity through the Unified National Access (NAFATH) or other relevant sources. And you acknowledge that your credit report may affect the acceptance of your payment request with Tamara depending on your repayment history and credit behaviour. Tamara might disclose the aggregated information with the Saudi Credit Bureau (SIMAH) or any other entity accredited by the Central Bank of Saudi Arabia (SAMA).',
  },
  {
    type: 'text',
    content:
      '<strong>11.13</strong> You hereby warrant and represent that you have sufficient funds available to satisfy any financial obligations towards Tamara as applicable from time to time. Tamara shall have the right to cooperate with the Merchant in the event you fail to fulfil your obligations to pay. Such cooperation includes, but is not limited to, suspension of the relevant subscription/services or seizing the product/goods until the payments are fulfilled.',
  },
  {
    type: 'text',
    content:
      '<strong>11.14</strong> You hereby agree that you understand and bear the potential consequences when you use the Finance Service in violation of the agreed terms. You agree that Tamara has the right (at her absolute discretion) to notify the Al Etihad Credit Bureau ("AECB") in the event of your delay or inability to pay.',
  },
  {
    type: 'text',
    content: `<strong>11.15</strong> You hereby agree that you are the true beneficiary of the Tamara Payment Services and that you do not use Tamara's Services for any money laundering or other illegal activities.`,
  },
  {
    type: 'subtitle',
    content: '12. Refund of Payments:',
  },
  {
    type: 'text',
    content:
      '<strong>12.1</strong> Tamara shall not be liable for any Merchant or Merchant Platform’s decision regarding Refunds, as applicable between you and the Merchant or the Merchant Platform. Tamara may elect, however, to play a role in facilitating such Refunds at its sole discretion, provided that such role does not imply any liability in connection with any Refund. Tamara will, however, remain responsible for processing the payment of any Refund as established between you and the Merchant or Merchant Platform.',
  },
  {
    type: 'subtitle',
    content: '13. Confidentiality and Privacy:',
  },
  {
    type: 'text',
    content:
      '<strong>13.1</strong> Tamara is committed to maintaining the confidentiality of credit information and data in its possession.',
  },
  {
    type: 'text',
    content:
      '<strong>13.2</strong> You hereby agree to provide any information, including Identification Information or documentation reasonably required by Tamara to verify your identity in connection with your Tamara Account or any use of Tamara Payment Services, and you authorise us to make any inquiries we believe are necessary in order to verify your identity. Tamara reserves the right to close your Tamara account or suspend or limit your access to Tamara Payment Services if we are unable to obtain or verify any such information to our satisfaction.',
  },
  {
    type: 'text',
    content:
      '<strong>13.3</strong> You hereby consent and authorize Tamara to use any or all of your personally identifiable information and personal data collected through Tamara websites, platforms or mobile applications or merchants from time to time and may be used or disclosed to other people. This may include sharing your identifying information and any other information with third parties for the purposes of credit verification, anti-money laundering or other similar checks or for any other purpose that Tamara considers necessary in order to enable Tamara to provide payment services to you and to comply with all applicable laws and regulations.',
  },
  {
    type: 'text',
    content:
      '<strong>13.4</strong> You hereby agree to these Terms and Conditions and when accessing or using the Tamara Website or Mobile App, you hereby agree to the Privacy Policy, knowing that your personal information is collected and understanding how it will be handled.',
  },
  {
    type: 'text',
    content:
      "<strong>13.5</strong> If you do not agree with our policies and practices, you will not be able to use Tamara's Website or Mobile App and please do not continue to use our Services.",
  },
  {
    type: 'text',
    content:
      '<strong>13.6</strong> You have the right to withdraw your consent to the processing of their personal data at any time, subject to contractual and statutory restrictions and written notice.',
  },
  {
    type: 'text',
    content:
      '<strong>13.7</strong> You shall not disclose to third parties any information received under these Terms and Conditions or any other contract concluded with Tamara. Any information related to Tamara’s business should be accessed in a confidential manner, within the limits that may negatively affect Tamara’s business, and you shall be responsible for compensating Tamara for any loss of business or reputation, if this occurs as a result of any act that results from your access of such information.',
  },
  {
    type: 'subtitle',
    content: '14. Limitation of Liability:',
  },
  {
    type: 'text',
    content:
      "<strong>14.1</strong> Tamara is an independent service provider and is not a party to any direct arrangements between Customers and Merchants or other related third parties. Tamara shall not in any way be liable for any claim or dispute attributable to Merchants and shall not be liable for any failure related to or damages caused by the Merchants' products or services’ mark, reliability, adequacy, originality, availability or legality.",
  },
  {
    type: 'text',
    content:
      '<strong>14.2</strong> Third-party Merchants are independent service providers who are not subject to these Terms and Conditions and are only contracting with Tamara. Merchants shall not be considered employees, representatives or agents of Tamara. Merchants are fully responsible for all dealings that take place between them and Customers or other related dealings, and in the event of a dispute between you and any Merchant or third party, you undertake to release Tamara from any liability arising from or related to such disputes. Such undertaking is to release Tamara (and its agents and employees) from claims, demands, liabilities and indemnities of any kind or nature, known or unknown, disclosed or undisclosed, arising out of or in any way related to such disputes.',
  },
  {
    type: 'text',
    content:
      '<strong>14.3</strong> By agreeing to these Terms and Conditions, you acknowledge the possibility of risks or errors arising from Merchants or any third-party service providers. Therefore, the use of the Tamara Services shall be your exclusive responsibility and Tamara does not bear any liability towards it.',
  },
  {
    type: 'text',
    content:
      '<strong>14.4</strong> Tamara shall not be liable to you or to any other person for any direct, indirect, incidental, special, penal, punitive or consequential damages that may arise, even if Tamara has been informed of the possibility of such damages, and Tamara shall not be liable for any damages, obligations or losses that you incur, arising from your use of or reliance on the Services, or as a result of your inability to access or use the Services, or from any Transaction or relationship that arose between you and a Merchant, even where Tamara was aware of the possibility of such damages occurring. Tamara shall not be responsible for any delay or failure in implementation, nor will it be held responsible in the event that a Merchant does not have the appropriate licenses and authorisations in place.',
  },
  {
    type: 'text',
    content: `<strong>14.5</strong> The Services are provided on an ‘as is’ basis, and Tamara disclaims all representations and warranties, express, implied, or statutory that are not expressly stated in these Terms and Conditions, including the implied warranties regarding the seller’s ability and suitability of its services for a particular purpose. Tamara does not make any representation or warranty about the reliability, quality, sustainability, availability or original owner of the services or goods or any services ordered through the use of Tamara's Services, nor does Tamara guarantee that the Services will be uninterrupted or error-free. To the fullest extent permitted by the Applicable Laws, you hereby acknowledge and agree that you assume all liability arising from your use of any of the Services offered by Tamara.`,
  },
  {
    type: 'text',
    content:
      '<strong>14.6</strong> The information on the Website and Mobile App is provided for general purposes only. Tamara shall make reasonable efforts to keep information up-to-date and correct, but does not provide any representations or warranties of any kind, whether express or implied, in terms of the completeness, accuracy, reliability, suitability or availability of the Website or Mobile App, information, services or related advertisements or graphics contained on the Website or Mobile App for any purpose, and therefore you shall rely on such information at your own risk.',
  },
  {
    type: 'text',
    content:
      '<strong>14.7</strong> For security and performance reasons, all Tamara Accounts are regularly monitored.',
  },
  {
    type: 'text',
    content:
      '<strong>14.8</strong> Tamara shall not be liable for any delay, interruption or failure in the provision of the Services caused by a Force Majeure event.',
  },
  {
    type: 'text',
    content:
      '<strong>14.9</strong> You hereby acknowledge and agree to indemnify and hold Tamara and any of its affiliates, officers, directors, employees and agents indemnified from and against any and all claims, liabilities, damages, losses, expenses or expenses, including without limitation, legal and accounting fees arising out of or in any way related to the following:',
  },
  {
    type: 'list',
    content: [
      '14.9.1. your access to, use of, or inability to use your Tamara Account or Tamara Services;',
      '14.9.2. Your negligence or misconduct.',
      '14.9.3. Your violation of any applicable laws.',
      '14.9.4. Your failure to provide and maintain true, accurate, current and  complete information in connection with your Tamara account.',
      '14.10. If you do not agree to any of these Terms and Conditions, you must not access the Website or Mobile App, nor use the Tamara Services',
    ],
  },
  {
    type: 'subtitle',
    content: '15. Pledge',
  },
  {
    type: 'text',
    content:
      '<strong>15.1</strong> This provision constitutes notice to you that we have pledged all of our rights, title and interest in and under these Terms and Conditions, including our right to any amount payable by you pursuant to these Terms and Conditions. We will remain entitled to exercise all our rights, powers, discretions and remedies under these Terms and Conditions, and you should continue to pay any amount payable by you pursuant to, and give notices under, these Terms and Conditions to us, unless and until you receive written notice to the contrary. In this event, all the rights, powers, discretions and remedies will be exercisable, and notices must be given, in accordance with that notice. By agreeing to these Terms and Conditions, you acknowledge and accept the terms of this clause.',
  },
  {
    type: 'subtitle',
    content: '16. Compensation:',
  },
  {
    type: 'text',
    content:
      '<strong>16.1</strong> You acknowledge and agree to indemnify and ward off damage from Tamara, its affiliate entities, sponsors, partners, directorate, liability, employees and reimbursement of all losses to them as well as the value of damages, liabilities, claims, judgments, settlements, fines, costs and expenses (including any expenses, legal fees, investigation costs, and attorneys’ fees). In case Tamara suffers any damages caused by you or if it arises or is related to your breach of these Terms and Conditions, the Privacy Policy or your or third party (by you) use of the Services.',
  },
  {
    type: 'subtitle',
    content: '17. Notifications:',
  },
  {
    type: 'text',
    content:
      '<strong>17.1</strong> All notifications and other communications under these Terms and Conditions shall be in writing by correspondence to the Tamara e-mail shown on the Tamara Website.',
  },
  {
    type: 'subtitle',
    content: '18. General',
  },
  {
    type: 'text',
    content:
      '<strong>18.1</strong> The rights and obligations of the parties stipulated in these Terms and Conditions shall be governed by and interpreted in accordance with the provisions of the laws of The Kingdom of Saudi Arabia.',
  },
  {
    type: 'text',
    content:
      '<strong>18.2</strong> By agreeing to these Terms and Conditions, you undertake to submit unconditionally to the exclusive jurisdiction of the courts of The Kingdom of Saudi Arabia for any legal proceedings arising out of or in connect with these Terms and Conditions, the legal relationships established by them, or the various subject matters hereof. The parties hereto hereby waive and agree not to assert (by way of motion, as a defence, or otherwise) that any such proceeding is brought in an inconvenient forum or that the venue thereof is improper.',
  },
  {
    type: 'text',
    content:
      '<strong>18.3</strong> You hereby agree to cooperate with Tamara to the fullest extent permitted by Applicable Laws, including agreeing to answer in writing any questions or providing information to assist Tamara in conducting any internal investigation or inquiry.',
  },
  {
    type: 'text',
    content:
      '<strong>18.4</strong> Under these Terms and Conditions, you acknowledge that Tamara may disclose information about you and your aforementioned account or any other account with any regulators under the Applicable Laws, any applicable bank card association rules in force from time to time, and/or the authorized representative of applicable regulators, including, but not limited to, the Saudi Credit Bureau (“SIMAH”) through the concluded membership agreement and the approved business rules for the exchange of information and/or to any other party as approved by the Saudi Central Bank (“SAMA”) or any other local applicable financial institution.',
  },
  {
    type: 'text',
    content:
      '<strong>18.5</strong> If any term or provision of these Terms and Conditions is determined to be ineffective, unenforceable or invalid, then only that term or provision shall be deemed invalid without affecting in any way the rest of these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>18.6</strong> These Terms and Conditions shall become effective on the date on which you      access our Website or Mobile App and/or indicate your acceptance by creating a Tamara Account and shall remain in effect until cancelled or revoked by Tamara at its full discretion.',
  },
  {
    type: 'text',
    content:
      '<strong>18.7</strong> If Tamara elects, at its sole discretion, to deactivate your access to the Tamara Account, subsequently terminating these Terms and Conditions, it will notify you by sending a notification to the email address you have provided to Tamara. You hereby agree and acknowledge that Tamara has the absolute right to terminate these Terms and Conditions with or without reason and has no obligation to notify you of the reason for the termination of these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>18.8</strong> By closing your Tamara Account by following the instructions on the Tamara Website or Mobile App, these Terms and Conditions will cease to apply. For the avoidance of doubt, you will remain liable for all obligations relating to your Tamara Account and all outstanding amounts that you owe Tamara (including late fees) even after your Tamara Account is closed and/or these Terms and Conditions cease to apply.',
  },
  {
    type: 'subtitle',
    content: '19. Complaints',
  },
  {
    type: 'text',
    content:
      '<strong>19.1</strong> We are committed to providing an excellent standard of service to our customers. We value feedback from customers greatly because it helps us to continually improve our service. If you do not feel that you are receiving excellent customer service, or that something could be improved, please do tell us about it.',
  },
  {
    type: 'text',
    content:
      '<strong>19.2</strong> If we have fallen short of the high standards we have set for ourselves then we would like the opportunity to put things right. However, we recognize that things can go wrong occasionally and if this occurs, we are committed to resolving matters promptly and fairly. Should you wish to make a complaint you may do so by communicating with us by the following methods: 8001240441.',
  },
  {
    type: 'text',
    content:
      '<strong>19.3</strong> Upon receiving your complaint, we will: (i) send a written acknowledgement of your complaint within five (5) business days of receiving it and inform you of any missing details; (ii) investigate the concerns and arrange a discussion with you to try to agree how to resolve the issues; (iii) respond with our final decision on the matter, setting out the conclusion of our investigation and any proposals to rectify or resolve the matter, within ten (10) business days of receiving your complete complaint; and (iv) remind you that you may be entitled to refer your complaint to the ﻿Saudi Central Bank (“SAMA”) and provide details for doing so, at the end of our complaints process.',
  },
  {
    type: 'subtitle',
    content: '20. Errors',
  },
  {
    type: 'text',
    content:
      '<strong>20.1</strong> Where we become aware of any error or malfunction to your Tamara Account, we will: (i) promptly return any collected amounts arising as a result of such error, as applicable; (ii) process and correct such errors for any affected customers within sixty (60) business days starting from the date of determining the error; and (iii) inform you of such error and that corrective measures have been taken.',
  },
  {
    type: 'text',
    content: '<strong>21</strong> Entire Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>21.1</strong> These Terms and Conditions, together with the Privacy Policy and any other terms agreed between you and Tamara from time to time represent the entire agreement between you and Tamara.',
  },
  {
    type: 'text',
    content:
      '<strong>21.2</strong> Hereby, I the undersigned agree to provide Nakhla for IT Systems LLC (Tamara)with any information that it requires for the establishing and/or auditing and/or administering my accounts and facilities therewith and I authorize it to obtain and collect any information as it deems necessary or in need for regarding me, my accounts and facilities therewith, from the Saudi Credit Bureau (SIMAH) and to disclose and share (inclusive of Data Pooling) that information to the said company (SIMAH) in accordance with the Membership Agreement and Code of Conduct approved or to any other agency approved by Saudi Central Bank (SAMA).',
  },
]
